import {
  Box,
  Button,
  DialogActions,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import DefaultModal from '../../../components/Modals/DefaultModal';

interface Props {
  closeModal: () => void;
  isOpen: boolean;
  confirmModal: (closeProject?: boolean) => void;
}

const DeclineModal = (props: Props): JSX.Element => {
  const [closeProject, setCloseProject] = useState<boolean>();

  return (
    <DefaultModal open={props.isOpen} handleClose={props.closeModal}>
      <Box
        sx={{ px: 6 }}
        alignItems="center"
        display="flex"
        flexDirection="column"
      >
        <Typography variant="h4" textAlign="center" color="grey.700" mb={3}>
          Create Invoice
        </Typography>
      </Box>
      <Box sx={{ px: 6 }}>
        <RadioGroup
          onChange={(e) => setCloseProject(e.target.value === 'true')}
        >
          <FormControlLabel
            value={true}
            control={<Radio />}
            sx={{ mb: 1 }}
            label="Close this project and create an invoice"
          />
          <FormControlLabel
            value={false}
            control={<Radio />}
            sx={{ mb: 4 }}
            label="Keep this project open and  create an invoice for a certain number of hours associated with this project"
          />
        </RadioGroup>
      </Box>
      <DialogActions sx={{ justifyContent: 'center', py: 3 }}>
        <Button variant="outlined" onClick={props.closeModal}>
          Cancel
        </Button>
        <Button
          disabled={closeProject === undefined}
          onClick={() => props.confirmModal(closeProject)}
        >
          Create
        </Button>
      </DialogActions>
    </DefaultModal>
  );
};

export default DeclineModal;
